module.exports = __webpack_public_path__ + "static/media/CGU-Wepix.42a95a67.pdf";